import VueBarcode from "vue-barcode";
import { Component, Mixins } from "vue-property-decorator";
import EditMixin from "../../mixins/edit.mixin";
import Template from "./barcodeEdit.template.vue";

@Component({
  mixins: [Template],
  components: {
    VueBarcode
  }
})
export default class BarcodeEditComponent extends Mixins(EditMixin) {
  constructor() {
    super();
  }
}
